import React, { useEffect } from 'react'
import TableFixedPage from '../TableFixedPage/TableFixedPage'
import { getAcountingApi } from '../../Api/PanelAdminServices'
import { errorToast } from '../../Utils/Toast/Toast'
import { useState } from 'react'
import OutComeTable from '../Tables/OutComeTable/OutComeTable'

const OutComeContainer = () => {
    const[outCome,setOutCome]=useState([])
    const[inCome,setinCome]=useState([])

    useEffect(()=>{
        getAcountingData()
    },[])
    const getAcountingData=()=>{
        getAcountingApi((succ,res)=>{
            if(succ){
                if(res.status===0){
                    errorToast("مشکلی پیش آمده است")
                }else{
                    setOutCome(res.outcome)
                    setinCome(res.income)
                }
            }else{
                errorToast("خطایی در سرور رخ داده است")
            }
        })
    }
 //////////////// data table ///////////////
    const data =outCome&&outCome.map((item) => {
        return {
            key: item.id,
            amount:item.amount,
            date:item.date,
            orderId:item.order_id,
            userId:item.user_id,
            type:item.user_type
        };
    });
  
  return (
    <div>
        <TableFixedPage title={"حسابداری"} />
        <OutComeTable data={data}/>
    </div>
  )
}


export default OutComeContainer